'use strict';

// Get the core js for a mobile app.
var mobileCore = require('mobile-core');

// Get portfolio specific js.

// Expose new browserify modules to legacy js.
module.exports = mobileCore;
